"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Fill_1 = require("../utility/Fill");
var Rounded_1 = require("../utility/Rounded");
var Size_1 = require("../utility/Size");
var ProgressBar = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var min = (_a = props.min) !== null && _a !== void 0 ? _a : 0;
    var max = ((_b = props.max) !== null && _b !== void 0 ? _b : 100) - min;
    var overfillMax = (_c = props.overfillMax) !== null && _c !== void 0 ? _c : max * 2;
    if (max < min) {
        console.error("ProgressBar min value cannot be larger than the max value");
        return null;
    }
    if (overfillMax < max) {
        console.error("ProgressBar overfillMax value cannot be smaller than the max value");
        return null;
    }
    var percent;
    var bgClass;
    if (props.value > max) {
        var overfillPercent = ((props.value - max) / (overfillMax - max)) * 100;
        percent = 100 - overfillPercent;
        bgClass = (_d = props.overfillFill) !== null && _d !== void 0 ? _d : Fill_1.Fill.Negative;
    }
    else {
        percent = ((props.value - min) / max) * 100;
        bgClass = (_e = props.backgroundFill) !== null && _e !== void 0 ? _e : Fill_1.Fill.Fade;
    }
    if (percent < 0) {
        percent = 0;
    }
    var classes = ["c-progress", bgClass, Rounded_1.Rounded.Pill, Size_1.Width.Fill];
    if (props.className) {
        classes.push(props.className);
    }
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    if (utilityClasses) {
        classes.push.apply(classes, utilityClasses);
    }
    return (react_1.default.createElement("div", { className: classes.join(" ") },
        react_1.default.createElement("div", { className: ((_f = props.normalFill) !== null && _f !== void 0 ? _f : Fill_1.Fill.Positive) + " u-block u-height-100pc u-pill", style: { width: percent + "%" } })));
};
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map